
// Hybrid auth

// https://github.com/zquestz/omniauth-google-oauth2
// https://developers.google.com/identity/sign-in/web/server-side-flow

// This initialization will be called from `auth/session/new` when it loaded.
window.googleAuthAsyncInit = function() {
  window.gapi.auth.authorize({
    immediate: true,
    response_type: 'token',
    cookie_policy: 'single_host_origin',
    client_id: window.gon.googleClientId,
    scope: 'email profile'
  }, function(response) {
    // Do nothing
    return;
  });
}

// Callback for after google authentication is succeeded.
function handleCallback(response) {
  function permissionFlag() {
    if (document.querySelector('#auth-form input[type="checkbox"][name="secure_user[mail_subscription]"]')) {
      return document.querySelector('#auth-form input[type="checkbox"][name="secure_user[mail_subscription]"]').checked;
    }
    return undefined;
  }

  if (response && !response.error) {
    const form = document.createElement('form');
    form.action = '/snow/auth/session/google_callback';
    form.method = 'post';

    const attributes = {
      token: response.access_token,
      authenticity_token: document.querySelector('#auth-form input[name="authenticity_token"]').value,
    };

    const permission = permissionFlag();
    // ログイン画面ではフラグがないので、その場合はinputを作らない
    if (permission !== undefined) {
      attributes.mail_subscription = permission ? '1' : '0';
    }

    Object.entries(attributes).forEach(([name, value]) => {
      const input = document.createElement('input');
      input.name = name;
      input.setAttribute('value', value);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  } else {
    const googleAuthButton = document.getElementById('google-auth-button');
    googleAuthButton.style.display = 'block';
    alert('Please reload browser and try again.');
    throw new Error(`Something happened, response: ${JSON.stringify(response)}`);
  }
}

// Add click event for google sign-in button
// Do not forget about turbolinks.
document.addEventListener('turbolinks:load', () => {
  const googleAuthButton = document.getElementById('google-auth-button');
  if (googleAuthButton == null) {
    return;
  }
  googleAuthButton.onclick = function (e) {
    e.preventDefault();
    e.target.style.display = 'none';
    window.gapi.auth.authorize({
      immediate: false,
      response_type: 'token',
      cookie_policy: 'single_host_origin',
      client_id: window.gon.googleClientId,
      scope: 'email profile'
    }, handleCallback);
  }
});
